import React from "react";

// hooks
import { useSiteHeaderScroll } from "./useSiteHeaderScroll";

// components
import SiteHeaderContent from "./SiteHeaderContent";

const SiteHeader = props => {
    const {
        isScrolledDown,
        animateElements,
        animateSearch
    } = useSiteHeaderScroll();

    return (
        <SiteHeaderContent
            {...props}
            isScrolledDown={isScrolledDown}
            animateElements={animateElements}
            animateSearch={animateSearch}
        />
    );
};

export default SiteHeader;
